import { Button } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { useSegmentTracking } from 'src/common/hooks/use-segment-tracking';
import { certificationAppBannerContent } from './certification-app-banner.content';
import { StyledBannerImage, StyledBannerImageWrapper, StyledBannerTextWrapper, StyledHeadingWrapper, StyledTitleSection } from './certification-app-banner.styles';
import type { CertificationAppBannerProps } from './certification-app-banner.types';
export const CertificationAppBanner = ({
  type
}: CertificationAppBannerProps) => {
  const navigate = useNavigate();
  const {
    triggerButtonClickEvent
  } = useSegmentTracking();
  const content = certificationAppBannerContent[type];
  if (!content) return null;
  const handleLearnMore = () => {
    triggerButtonClickEvent(content.segmentEventName, content.segmentEventCategory, content.segmentEventAction);
    navigate(content.learnMorePath);
  };
  return <>
      <StyledBannerTextWrapper $certificationType={type} data-sentry-element="StyledBannerTextWrapper" data-sentry-source-file="certification-app-banner.tsx">
        <StyledHeadingWrapper data-sentry-element="StyledHeadingWrapper" data-sentry-source-file="certification-app-banner.tsx">
          <span>NEW</span>
          <h1>
            {content.title}{' '}
            {content.highlightedTitle && <StyledTitleSection>{content.highlightedTitle}</StyledTitleSection>}{' '}
            {content.subtitle}
          </h1>
        </StyledHeadingWrapper>
        <p>{content.description}</p>
        <Button color="primary" variant="solid" onClick={handleLearnMore} data-sentry-element="Button" data-sentry-source-file="certification-app-banner.tsx">
          {content.buttonText}
        </Button>
      </StyledBannerTextWrapper>
      <StyledBannerImageWrapper data-sentry-element="StyledBannerImageWrapper" data-sentry-source-file="certification-app-banner.tsx">
        <StyledBannerImage src={content.image} alt="Certification" $certificationType={type} data-sentry-element="StyledBannerImage" data-sentry-source-file="certification-app-banner.tsx" />
      </StyledBannerImageWrapper>
    </>;
};